export class InsuranceLog {
    LogId: number;
    ActionType: number;
    ActionTypeName: string;
    InsuranceProvider: string;
    ChangedByName: string;
    ChangedDate: Date;
    FieldsChangedCount: number;
}
